import type { IntegrationFactory } from './factory';
export const dwhFactory: IntegrationFactory = async (config) => {
  const url = config.getOrThrow('DWH_URL') as unknown as string;
  const { DWH } = await import('@cp/shared/tracking/integrations/dwh');
  return new DWH({ url });
};
